import type {
    BusinessPourAvailability,
    Pagination,
} from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'businesses/pour-availabilities';

export function getPourAvailabilities(
    query: BusinessPourAvailability.SearchQuery
) {
    return api.get<Pagination<BusinessPourAvailability>>(rootPath, query);
}

export function getPourAvailability(id: number) {
    return api.get<BusinessPourAvailability.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postPourAvailability(
    data: BusinessPourAvailability.CreateRequest
) {
    return api.post<BusinessPourAvailability>(rootPath, data);
}

export function putPourAvailability(
    id: number,
    data: BusinessPourAvailability.UpdateRequest
) {
    return api.put<BusinessPourAvailability>(`${rootPath}/${id}`, data);
}

export function deletePourAvailability({
    id,
}: BusinessPourAvailability.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
